const topics = [
  { label: '科幻大片', heat: '9.8w', icon: 'ri-rocket-2-line' },
  { label: '悬疑推理', heat: '8.5w', icon: 'ri-search-eye-line' },
  { label: '动漫番剧', heat: '8.9w', icon: 'ri-ghost-line' },
  { label: '古装仙侠', heat: '7.2w', icon: 'ri-sword-line' },
  { label: '韩剧推荐', heat: '7.6w', icon: 'ri-heart-pulse-line' },
  { label: '都市爱情', heat: '6.9w', icon: 'ri-hearts-line' },
  { label: '搞笑喜剧', heat: '6.1w', icon: 'ri-emotion-laugh-line' },
  { label: '恐怖惊悚', heat: '5.4w', icon: 'ri-ghost-smile-line' },
  { label: '纪录片', heat: '4.3w', icon: 'ri-earth-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              全网影迷正在热议的影视话题，即刻加入讨论
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-800/50 border border-background-700/30 rounded-xl hover:border-primary-500/30 hover:bg-background-800/80 transition-all duration-300 cursor-pointer"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${topic.icon} text-lg`}></i>
                </span>
                <span className="text-sm text-foreground-200 font-medium group-hover:text-primary-300 transition-colors whitespace-nowrap">
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-500 bg-background-700/50 px-2.5 py-0.5 rounded-full">
                  热度 {topic.heat}
                </span>
              </a>
            ))}
            <div className="hidden lg:flex col-span-1 items-center justify-center p-5 md:p-6 bg-accent-500/8 border border-accent-500/15 rounded-xl">
              <div className="text-center">
                <i className="ri-add-line text-accent-400 text-xl mb-1 block"></i>
                <span className="text-xs text-accent-400">更多话题</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}